import { render, staticRenderFns } from "./xuexiao-detail.vue?vue&type=template&id=87932350&scoped=true&"
import script from "./xuexiao-detail.vue?vue&type=script&lang=js&"
export * from "./xuexiao-detail.vue?vue&type=script&lang=js&"
import style0 from "./xuexiao-detail.vue?vue&type=style&index=0&id=87932350&lang=scss&scoped=true&"
import style1 from "./xuexiao-detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87932350",
  null
  
)

export default component.exports